import { useEffect } from "react";
import {
  isNewVersionAvailable,
  subscribeToDeployedVersion,
} from "@/lib/application-version";
import { toast } from "@/lib/toast";

const NEW_VERSION_TOAST_ID = "new-version";

function showWhenNewVersionAvailable() {
  if (!isNewVersionAvailable()) {
    return;
  }

  toast.info("A new version of FieldPay is available.", {
    id: NEW_VERSION_TOAST_ID,
    duration: Infinity,
    action: { label: "Reload", onClick: () => window.location.reload() },
  });
}

export function NewVersionToast() {
  useEffect(() => {
    showWhenNewVersionAvailable();

    return subscribeToDeployedVersion(showWhenNewVersionAvailable);
  }, []);

  return null;
}
